<div *ngIf="error" class="alert alert-warning" role="alert">
  {{ errorMsg }}
</div>
<form (ngSubmit)="onSubmit()" [formGroup]="form" autocomplete="off">
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label i18n>Pessoa</label>
        <div class="row">
          <div class="col-4 pl-0">
            <select
              formControlName="tipo"
              (change)="formatDocument($event.target.value)"
              [class]="edit ? 'form-control select-tipo-pessoa-cadastro-cliente' : 'form-control'"
              [disabled]="edit"
            >
              <option value="CNPJ">Jurídica</option>
              <option value="CPF">Física</option>
            </select>
          </div>
          <div class="col-8 pr-0">
            <input
              id="numDocumento1"
              formControlName="numDocumento1"
              placeholder="{{ documentLabel1 }}"
              (blur)="consultaCnpj($event)"
              name="numDocumento1"
              type="text"
              [mask]="documentMask"
              [dropSpecialCharacters]="false"
              class="form-control"
              [readonly]="edit"
            />
            <div
              *ngIf="error && form.get('numDocumento1').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <div class="col-4 pl-0">
            <label i18n>Tipo Empresa</label>
            <select *ngIf="nomeLabel2" formControlName="tipo_empresa" class="form-control">
              <option *ngFor="let t of tipo_empresa" value="{{ t.id }}">
                {{ t.label }}
              </option>
            </select>
            <select *ngIf="!nomeLabel2" formControlName="tipo_empresa" class="form-control">
              <option *ngFor="let t of tipo_empresaPF" value="{{ t.id }}">
                {{ t.label }}
              </option>
            </select>
            <div
              *ngIf="error && form.get('tipo_empresa').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
          <div class="col-6 pr-0">
            <label i18n>{{ documentLabel2 }}</label>
            <input
              id="numDocumento2"
              formControlName="numDocumento2"
              placeholder="{{ documentLabel2 }}"
              name="numDocumento2"
              type="text"
              class="form-control"
              maxlength="20"
              [readOnly]="isentoIE"
            />
            <div
              *ngIf="error && form.get('numDocumento2').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
          <div class="col-2 pr-0">
            <label class="form-check-label" for="flexCheckDefault" [style]="'display: flex'">
              Isento
            </label>
            <div style="display: flex; margin-left: 1rem;">
              <input class="form-check-input" type="checkbox" (change)="this.isentoIE = !this.isentoIE" id="flexCheckDefault">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label i18n>{{ nomeLabel1 }}</label>
        <input
          formControlName="nome1"
          name="nome1"
          type="text"
          maxlength="60"
          class="form-control"
        />
        <div *ngIf="error && form.get('nome1').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div *ngIf="nomeLabel2" class="form-group">
        <label i18n>{{ nomeLabel2 }}</label>
        <input
          formControlName="nome2"
          name="nome2"
          type="text"
          maxlength="255"
          class="form-control"
        />
        <div *ngIf="error && form.get('nome2').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="form-group">
        <label i18n>Email Login</label>
        <input
          id="email-cadastro-cliente"
          formControlName="email"
          name="email"
          type="email"
          maxlength="255"
          class="form-control"
        />
        <div *ngIf="error && form.get('email').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="form-group">
        <label i18n>Email Contato</label>
        <input
          formControlName="emailContato"
          id="email-contato-cadastro-cliente"
          name="emailContato"
          type="email"
          maxlength="255"
          class="form-control"
        />
        <!-- <div *ngIf="error && form.get('email').invalid" class="error">
          Verifique este campo!
        </div> -->
     </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>Suframa</label>
            <input
              formControlName="suframa"
              name="suframa"
              type="text"
              class="form-control"
              data-toggle="tooltip"
              data-placement="top"
              title="Apenas para clientes inscritos no suframa"
              id="suframa-cadastro-cliente"
            />
            <div *ngIf="errorMsg && form.get('suframa').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>Referências Comerciais</label>
            <input
              maxlength="255"
              formControlName="observacao"
              name="observacao"
              type="text"
              class="form-control"
              (input)="sanitizeInput($event)"
              id="ref-cadastro-cliente"
            />
            <div
              *ngIf="errorMsg && form.get('observacao').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="form-group mt-3">
        <div class="row">
          <div class="col-12 pl-0 pr-0">
            <!-- <table
              class="table table-hover table-sm"
              [innerHtml]="tableInfoDoc"
            ></table> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label i18n>Endereço</label>
            <input
              formControlName="endereco"
              name="endereco"
              type="text"
              maxlength="255"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('endereco').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label i18n>Número</label>
            <input
              formControlName="numero"
              name="numero"
              type="text"
              maxlength="10"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('numero').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label i18n>Bairro</label>
            <input
              formControlName="bairro"
              name="bairro"
              type="text"
              maxlength="255"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('bairro').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label i18n>CEP</label>
            <input
              formControlName="cep"
              name="cep"
              type="text"
              mask="00000-000"
              [dropSpecialCharacters]="true"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('cep').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label i18n>Complemento</label>
            <input
              formControlName="complemento"
              name="complemento"
              type="text"
              maxlength="255"
              class="form-control"
            />
            <div
              *ngIf="errorMsg && form.get('complemento').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label i18n>Contato</label>
            <input
              formControlName="contato"
              name="contato"
              type="text"
              maxlength="50"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('contato').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>UF</label>
            <select
              formControlName="uf"
              name="uf"
              (change)="searchCities()"
              class="form-control"
            >
              <option *ngFor="let uf of ufs" value="{{ uf }}">{{ uf }}</option>
            </select>
            <div *ngIf="errorMsg && form.get('uf').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>Cidade</label>
            <select
              formControlName="cidade"
              id="cidade"
              name="cidade"
              class="form-control"
            >
              <option *ngFor="let city of cities" value="{{ city.id }}">
                {{ city.nome }}
              </option>
            </select>
            <div *ngIf="errorMsg && form.get('cidade').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>Telefone</label>
            <input
              formControlName="ddd"
              name="ddd"
              type="text"
              mask="00"
              placeholder="DDD"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('ddd').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>&nbsp;</label>
            <input
              formControlName="telefone"
              name="telefone"
              type="text"
              mask="0000-0000"
              [validation]="false"
              [dropSpecialCharacters]="false"
              placeholder="Número"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('telefone').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label i18n>Whatsapp</label>
            <input
              formControlName="dddWhatsapp"
              name="dddWhatsapp"
              type="text"
              mask="00"
              placeholder="DDD"
              class="form-control"
            />
            <div
              *ngIf="errorMsg && form.get('dddWhatsapp').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label i18n>&nbsp;</label>
            <input
              formControlName="telefoneWhatsapp"
              name="telefoneWhatsapp"
              type="text"
              mask="00000-0000"
              [validation]="false"
              [dropSpecialCharacters]="false"
              placeholder="Número"
              class="form-control"
            />
            <div
              *ngIf="errorMsg && form.get('telefoneWhatsapp').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 pl-0" *ngIf="cadastros">
        <div class="form-group">
          <label i18n>Tipo de cliente</label>
          <select
            formControlName="tipo_cliente"
            name="tipo_cliente"
            [class]="edit ? 'form-control select-tipo-pessoa-cadastro-cliente' : 'form-control'"
          >
            <option class="tipo-cliente-varejo" value="varejo">Varejo</option>
            <option class="tipo-cliente-atacado" value="atacado">Atacado</option>            
            <option class="tipo-cliente-franquia" value="franquia">Franquia</option>
          </select>
          <div *ngIf="errorMsg && form.get('tipo_cliente').invalid" class="error">
            Verifique este campo!
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <button i18n class="btn btn-primary" *ngIf="this.edit; else btntitle"> 
        Salvar
      </button>
      <ng-template #btntitle>
        <button i18n class="btn btn-primary">
          Cadastrar
        </button>
      </ng-template>
    </div>
  </div>
</form>
